import { useTranslation } from 'react-i18next';

export type SidebarMenuAction = 'logout';

export type SidebarMenuItem = {
  id: string;
  label: string;
  icon: string;
  path?: string;
  action?: SidebarMenuAction;
};

export type SidebarMenuGroup = {
  title: string;
  items: SidebarMenuItem[];
};

type SidebarProps = {
  navGroups: SidebarMenuGroup[];
  footerItems: SidebarMenuItem[];
  activeMenuId: string;
  onMenuClick: (item: SidebarMenuItem) => void;
};

export default function Sidebar({ navGroups, footerItems, activeMenuId, onMenuClick }: SidebarProps) {
  const { t } = useTranslation();
  return (
    <aside className="portal-sidebar">
      <div className="portal-sidebar-brand">
        <div className="portal-sidebar-mark">e</div>
        <div className="portal-sidebar-brand-copy">
          <p className="portal-sidebar-brand-name">
            elen1<span>.</span>
          </p>
          <p className="portal-sidebar-brand-sub">{t('nav.brandSub')}</p>
        </div>
      </div>
      <div className="portal-sidebar-menu">
        {navGroups.map((group) => (
          <div key={group.title} className="portal-sidebar-group">
            <p className="portal-sidebar-group-title">{group.title}</p>
            <div className="portal-sidebar-items">
              {group.items.map((item) => (
                <button
                  key={item.id}
                  type="button"
                  className={`portal-sidebar-item ${activeMenuId === item.id ? 'active' : ''}`}
                  onClick={() => onMenuClick(item)}
                >
                  <i className={`ph ${item.icon} portal-sidebar-item-icon`} aria-hidden="true" />
                  {item.label}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className="portal-sidebar-footer">
        {footerItems.map((item) => (
          <button
            key={item.id}
            type="button"
            className={`portal-sidebar-item ${activeMenuId === item.id ? 'active' : ''} ${item.action ? 'logout' : ''}`}
            onClick={() => onMenuClick(item)}
          >
            <i className={`ph ${item.icon} portal-sidebar-item-icon`} aria-hidden="true" />
            {item.label}
          </button>
        ))}
      </div>
    </aside>
  );
}
